<template>
    <div class="job-row-card col-12" v-on:click="show()" v-on:mouseenter="hover = true" v-on:mouseleave="hover = false">
        <div class="job-row-card--container">
            <div class="job-row-card--container-left">
                <div class="job-row-card--info">
                    <div class="job-row-card--info-top">
                        <h3 class="job-row-card--info-top-title">{{job.name}}</h3>
                    </div>
                    <div class="job-row-card--info-middle">
                        <svg-image class="job-row-card--info-middle-icon" :src="'/svg/' + resource_group + '/pin.svg'" color="black" highlight="primary"></svg-image>
                        <h6 class="job-row-card--info-middle-location">
                            {{startDateHasPassed ? 'started on ' + job.start_date_formatted : 'starting on ' + job.start_date_formatted}}
                        </h6>
                    </div>
                    <div class="job-row-card--info-middle">
                        <svg-image class="job-row-card--info-middle-icon" :src="'/svg/' + resource_group + '/check.svg'" color="primary" highlight="primary"></svg-image>
                        <h6 class="job-row-card--info-middle-location text-primary">
                            <span>{{ job.user_job_role.description }}</span>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="job-row-card--container-right">
                <svg-image class="job-row-card--button" color="light-grey" highlight="primary" :hover="hover" :src="'/svg/' + resource_group + '/chevron-right.svg'"></svg-image>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "OperativeJobCard",
        props: [
        	'job',
            'show_url'
        ],

        data() {
		    return {
                hover: false,
                hoverList: false
            }
        },

        methods: {
			show(){
				window.location.href = this.show_url;
            }
        },
    computed: {
        startDateHasPassed(){
            const parsed_date_string = this.job.start_date_formatted.replace('th', '').replace('nd', '').replace('rd', '');
            return Date.parse(new Date()) > Date.parse(parsed_date_string);
        }
    }   
}   
</script>
